import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isTokenExpired } from './auth';

// Define allowed paths per userType (all lowercase)
const roleBasedAccess = {
  cashier: [
    "/dashboard/cashier",
    "/sale/posgst",
    "/sale/newpos",
    "/sale/pos",
    "/sale/newsale",
    "/sale/vatsale",
    "/pos/ticketbilling",
    "/pos/cashier-summary",
    "/reports/billhistory",
    
    "/pos/bills-management",
    "/reports/saleledger",
    "/reports/dayclose",
    "/vouchers/recieptvoucher",
    "/vouchers/paymentvoucher",
    "/login",
    "/logout",
  ],
  account: [
    "/dashboard/account",
    "/reports/billhistory",
    "/reports/saleledger",
    "/reports/supplierledger",
    "/reports/supplierledger",
    "/inventory/stockreports",
    "/logout",
  ],
  manager: [
    "/dashboard/manager",
    "/dashboard/admin", // Managers can also access admin dashboard
    "/reports/billhistory",
    "/reports/saleledger", 
    "/reports/supplierledger",
    "/inventory/stockreports",
    "/reports/lowstockitems",
    "/vouchers/recieptvoucher",
    "/vouchers/paymentvoucher",
    "/logout",
  ],
  admin: "all", // admin can access all routes
  // Add other roles here if needed
};

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const userType = (localStorage.getItem('usertype') || sessionStorage.getItem('usertype') || '').toLowerCase();

  if (!token || isTokenExpired()) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!userType) {
    return <Navigate to="/accessdenied" state={{ from: location }} replace />;
  }

  const allowedPaths = roleBasedAccess[userType];

  if (allowedPaths !== "all" && !allowedPaths.includes(location.pathname.toLowerCase())) {
    return <Navigate to="/accessdenied" replace />;
  }

  return children;
};

export default PrivateRoute;
